
const ValidacionStatsStrip = () => {
    return (
        <div className="flex border-b border-gray-200 shrink-0 overflow-x-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
            <div className="flex-1 py-3.5 px-6 border-r border-gray-200 flex items-center gap-3 bg-white min-w-[180px]">
                <div className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0 bg-amber-50">
                    <svg width="18" height="18" fill="none" stroke="#f59e0b" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
                </div>
                <div>
                    <div className="font-mono text-lg font-bold text-amber-500">8</div>
                    <div className="text-[11px] text-gray-500 mt-0.5">Pendientes</div>
                </div>
            </div>

            <div className="flex-1 py-3.5 px-6 border-r border-gray-200 flex items-center gap-3 bg-white min-w-[180px]">
                <div className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0 bg-indigo-50">
                    <svg width="18" height="18" fill="none" stroke="#4f6df5" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /></svg>
                </div>
                <div>
                    <div className="font-mono text-lg font-bold text-[#4f6df5]">3</div>
                    <div className="text-[11px] text-gray-500 mt-0.5">En revisión</div>
                </div>
            </div>

            <div className="flex-1 py-3.5 px-6 border-r border-gray-200 flex items-center gap-3 bg-white min-w-[180px]">
                <div className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0 bg-emerald-50">
                    <svg width="18" height="18" fill="none" stroke="#10b981" strokeWidth="2" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" /></svg>
                </div>
                <div>
                    <div className="font-mono text-lg font-bold text-emerald-600">24</div>
                    <div className="text-[11px] text-gray-500 mt-0.5">Aprobados (mes)</div>
                </div>
            </div>

            <div className="flex-1 py-3.5 px-6 flex items-center gap-3 bg-white min-w-[180px]">
                <div className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0 bg-red-50">
                    <svg width="18" height="18" fill="none" stroke="#ef4444" strokeWidth="2" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
                </div>
                <div>
                    <div className="font-mono text-lg font-bold text-red-600">4</div>
                    <div className="text-[11px] text-gray-500 mt-0.5">Rechazados (mes)</div>
                </div>
            </div>
        </div>
    );
};

export default ValidacionStatsStrip;